"use client";
import PropTypes from "prop-types";

import { useEffect, useState } from "react";
import { LazyImage } from "components/common/lazy-image/LazyImage";
import { useEnvContext } from "next-runtime-env";

import styles from "./styles.module.css";

const NewsCard = ({ data }) => {
  const { NEXT_PUBLIC_EJ_APP_CANONICAL_HOST } = useEnvContext();
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    if (data?.publishedAt) {
      setFormattedDate(
        new Date(data.publishedAt).toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );
    }
  }, [data?.publishedAt]);

  return (
    <a href={`${NEXT_PUBLIC_EJ_APP_CANONICAL_HOST || ""}/haber/haber/${data?.slug || ""}/`} className={styles.wrapper}>
      {data?.cover?.medium && <LazyImage src={data.cover.medium} className={styles.media} />}
      <div className={styles.content}>
        <h3 className={styles.title}>{data?.title || ""}</h3>
        <span className={styles.info}>{data?.content?.brief || ""}</span>
        {formattedDate && <span className={styles.date}>{formattedDate}</span>}
      </div>
    </a>
  );
};

NewsCard.propTypes = {
  data: PropTypes.shape({
    slug: PropTypes.string,
    cover: PropTypes.shape({
      medium: PropTypes.string,
    }),
    title: PropTypes.string,
    content: PropTypes.shape({
      brief: PropTypes.string,
    }),
    publishedAt: PropTypes.string,
  }),
};

export default NewsCard;
